<script setup>
import { ref } from 'vue';
import { useConversationLabels } from 'dashboard/composables/useConversationLabels';
import LabelItem from 'dashboard/components-next/label/LabelItem.vue';
import ButtonV4 from 'dashboard/components-next/button/Button.vue';
import LabelDropdown from 'shared/components/ui/label/LabelDropdown.vue';

const {
  accountLabels,
  savedLabels,
  activeLabels,
  addLabelToConversation,
  removeLabelFromConversation,
} = useConversationLabels();

const hoveredLabel = ref(null);
const showLabelDropdown = ref(false);

const handleRemoveLabel = label => {
  removeLabelFromConversation(label.title);
};

const toggleLabelDropdown = () => {
  showLabelDropdown.value = !showLabelDropdown.value;
};

const closeLabelDropdown = () => {
  showLabelDropdown.value = false;
};

const handleMouseLeave = () => {
  hoveredLabel.value = null;
};
</script>

<template>
  <div
    v-on-clickaway="closeLabelDropdown"
    class="relative flex flex-wrap items-center gap-1 min-w-0 max-w-full"
    @mouseleave="handleMouseLeave"
    @keyup.esc="closeLabelDropdown"
  >
    <LabelItem
      v-for="label in activeLabels"
      :key="label.id"
      :label="label"
      always-show-remove
      :is-hovered="hoveredLabel === label.id"
      @remove="handleRemoveLabel"
      @hover="hoveredLabel = label.id"
    />
    <ButtonV4
      v-tooltip="$t('CONTACT_PANEL.LABELS.CONVERSATION.ADD_BUTTON')"
      :aria-label="$t('CONTACT_PANEL.LABELS.CONVERSATION.ADD_BUTTON')"
      type="button"
      size="xs"
      variant="ghost"
      color="slate"
      icon="i-lucide-plus"
      class="!h-7 !px-2 !rounded-md shrink-0 !bg-n-alpha-2 text-n-slate-12 hover:enabled:!bg-n-alpha-2"
      :label="$t('LABEL.TAG_BUTTON')"
      @click="toggleLabelDropdown"
    />
    <div
      v-if="showLabelDropdown"
      class="absolute z-[9999] w-80 max-w-[calc(100vw-2rem)] p-2 mt-1 border rounded-lg shadow-lg bg-n-alpha-3 top-full backdrop-blur-[100px] border-n-strong ltr:right-0 rtl:left-0"
    >
      <LabelDropdown
        :account-labels="accountLabels"
        :selected-labels="savedLabels"
        allow-creation
        @add="addLabelToConversation"
        @remove="removeLabelFromConversation"
      />
    </div>
  </div>
</template>
